export const pushNoty = (noty) => {
  return (dispatch) => {
    return dispatch({
      type: 'PUSH_NOTY',
      payload: noty
    })
  }
}
